export default "__VITE_ASSET__DpDOVjvF__"